// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Default styles for larger screens */
.contact-container {
    display: flex;
    align-items: center;
    margin-top: 30px;
}

.contact-us {
    flex-wrap: wrap;
    align-items: center;
    text-align: center;
    width: 600px;
    height: auto;
    margin-left: 60px;
}

.contact-input-filed,
.input-field-message {
    margin: 10px 0;
    padding: 10px;
    font-size: 16px;
    border: 1px solid #ccc;
    border-radius: 5px;
    transition: box-shadow 0.3s ease-in-out;
    width: 400px;
}

.contact-input-filed::-webkit-outer-spin-button,
.contact-input-filed::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.contact-input-filed[type=number] {
    -moz-appearance: textfield;
}

.contact-input-filed:focus,
.input-field-message:focus {
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
}

.contact-image {
    width: 350px;
    transition: transform 0.5s ease-in-out;
}

.contact-image:hover {
    transform: rotate(5deg);
}

.contact-image-container {
    text-align: center;
    margin-right: 60px;
}
/* Waving animation */
@keyframes wave {
    0% { transform: rotate(0deg); }
    50% { transform: rotate(10deg); }
    100% { transform: rotate(0deg); }
  }
  
  /* Button that will wave when clicked */
  .button.waving {
    animation: wave 0.5s infinite;
  }
  
  /* Sending effect */
  .button.sending {
    position: relative;
    padding-left: 30px; /* Space for the spinner */
  }
  
  .button.sending::before {
    content: '';
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
    width: 18px;
    height: 18px;
    border: 3px solid #fff;
    border-top: 3px solid transparent;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }
  
  /* Spinner animation */
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  
  /* Styles for the "Waved" state */
  .button.waved {
    background-color: #4CAF50; /* Green color */
    color: white;
  }
  
/* Media query for smaller screens */
@media (max-width: 768px) {
    .contact-container {
        flex-direction: column;
        align-items: center;
    }

    .contact-us {
        max-width: 350px ;
        margin-left: 1px;
    }

    .contact-input-filed,
    .input-field-message {
        width:300px;
    }

    .contact-image-container {
        text-align: center;
        margin-right: 0;
        margin-top: 15px; /* Optional: Add some spacing between .contact-container and .contact-image-container on mobile */
    }

    .contact-image {
        width: 100%;
        max-width: 300px;
        margin: 0 auto;
    }
}
`, "",{"version":3,"sources":["webpack://./src/FrontEnd/Contact/Contact.css"],"names":[],"mappings":"AAAA,sCAAsC;AACtC;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,iBAAiB;AACrB;;AAEA;;IAEI,cAAc;IACd,aAAa;IACb,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,uCAAuC;IACvC,YAAY;AAChB;;AAEA;;IAEI,wBAAwB;IACxB,SAAS;AACb;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;;IAEI,uCAAuC;AAC3C;;AAEA;IACI,YAAY;IACZ,sCAAsC;AAC1C;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;AACA,qBAAqB;AACrB;IACI,KAAK,uBAAuB,EAAE;IAC9B,MAAM,wBAAwB,EAAE;IAChC,OAAO,uBAAuB,EAAE;EAClC;;EAEA,uCAAuC;EACvC;IACE,6BAA6B;EAC/B;;EAEA,mBAAmB;EACnB;IACE,kBAAkB;IAClB,kBAAkB,EAAE,0BAA0B;EAChD;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,iCAAiC;IACjC,kBAAkB;IAClB,kCAAkC;EACpC;;EAEA,sBAAsB;EACtB;IACE,KAAK,uBAAuB,EAAE;IAC9B,OAAO,yBAAyB,EAAE;EACpC;;EAEA,iCAAiC;EACjC;IACE,yBAAyB,EAAE,gBAAgB;IAC3C,YAAY;EACd;;AAEF,oCAAoC;AACpC;IACI;QACI,sBAAsB;QACtB,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;;QAEI,WAAW;IACf;;IAEA;QACI,kBAAkB;QAClB,eAAe;QACf,gBAAgB,EAAE,iGAAiG;IACvH;;IAEA;QACI,WAAW;QACX,gBAAgB;QAChB,cAAc;IAClB;AACJ","sourcesContent":["/* Default styles for larger screens */\n.contact-container {\n    display: flex;\n    align-items: center;\n    margin-top: 30px;\n}\n\n.contact-us {\n    flex-wrap: wrap;\n    align-items: center;\n    text-align: center;\n    width: 600px;\n    height: auto;\n    margin-left: 60px;\n}\n\n.contact-input-filed,\n.input-field-message {\n    margin: 10px 0;\n    padding: 10px;\n    font-size: 16px;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    transition: box-shadow 0.3s ease-in-out;\n    width: 400px;\n}\n\n.contact-input-filed::-webkit-outer-spin-button,\n.contact-input-filed::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\n\n.contact-input-filed[type=number] {\n    -moz-appearance: textfield;\n}\n\n.contact-input-filed:focus,\n.input-field-message:focus {\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);\n}\n\n.contact-image {\n    width: 350px;\n    transition: transform 0.5s ease-in-out;\n}\n\n.contact-image:hover {\n    transform: rotate(5deg);\n}\n\n.contact-image-container {\n    text-align: center;\n    margin-right: 60px;\n}\n/* Waving animation */\n@keyframes wave {\n    0% { transform: rotate(0deg); }\n    50% { transform: rotate(10deg); }\n    100% { transform: rotate(0deg); }\n  }\n  \n  /* Button that will wave when clicked */\n  .button.waving {\n    animation: wave 0.5s infinite;\n  }\n  \n  /* Sending effect */\n  .button.sending {\n    position: relative;\n    padding-left: 30px; /* Space for the spinner */\n  }\n  \n  .button.sending::before {\n    content: '';\n    position: absolute;\n    left: 10px;\n    top: 50%;\n    transform: translateY(-50%);\n    width: 18px;\n    height: 18px;\n    border: 3px solid #fff;\n    border-top: 3px solid transparent;\n    border-radius: 50%;\n    animation: spin 1s linear infinite;\n  }\n  \n  /* Spinner animation */\n  @keyframes spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n  }\n  \n  /* Styles for the \"Waved\" state */\n  .button.waved {\n    background-color: #4CAF50; /* Green color */\n    color: white;\n  }\n  \n/* Media query for smaller screens */\n@media (max-width: 768px) {\n    .contact-container {\n        flex-direction: column;\n        align-items: center;\n    }\n\n    .contact-us {\n        max-width: 350px ;\n        margin-left: 1px;\n    }\n\n    .contact-input-filed,\n    .input-field-message {\n        width:300px;\n    }\n\n    .contact-image-container {\n        text-align: center;\n        margin-right: 0;\n        margin-top: 15px; /* Optional: Add some spacing between .contact-container and .contact-image-container on mobile */\n    }\n\n    .contact-image {\n        width: 100%;\n        max-width: 300px;\n        margin: 0 auto;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
